<!-- <mat-toolbar *ngIf="hideModals" class="editor-toolbar mat-elevation-z0">
<div *ngFor="let command of footnoteMenu" class="flex group">
  <span class="flex">
    <div class="flex">
      <button mat-icon-button (click)="execCommand(command)" [disabled]="!command.active">
        <mat-icon [svgIcon]="command.svgIcon" *ngIf="command.svgIcon"
        [matTooltip]="command.tooltip || ''" matTooltipClass="tooltip"></mat-icon>
        <mat-icon *ngIf="!command.svgIcon" [matTooltip]="command.tooltip || ''"
        matTooltipClass="tooltip">{{ command.materialIconName }}</mat-icon>
      </button>
    </div>
  </span>
</div>
</mat-toolbar> -->

<div #sfoEditorOverlayContainer class="editor-overlay"></div>

<div id="editorWrapper" class="editor-wrapper" #editorWrapper translate="no">
  @if (!hideModals) {
    <div class="editor-toolbar mt1 rounded mat-elevation-z1">
      @if (!simpleMode) {
        @if (state$ | async; as state) {
          <mat-toolbar class="toolbar p0">
            @if (menu$ | async; as menuItems) {
              @if (menuItems.length > 0) {
                @for (group of menuItems; track group.id) {
                  <div class="flex group">
                    @if (group.id==='format' && group.commands.length > 0) {
                      <span class="flex flex-wrap">
                        @for (command of group.commands; track command.id ?? command.tooltip ?? command.materialIconName ?? $index) {
                          <div class="flex">
                            <button mat-icon-button (click)="execCommand(command)" [disabled]="!command.active || inActiveMainMenu">
                              @if (command.svgIcon) {
                                <mat-icon [svgIcon]="command.svgIcon" [matTooltip]="command.tooltip || ''"
                                matTooltipClass="tooltip"></mat-icon>
                              }
                              @if (!command.svgIcon) {
                                <mat-icon [matTooltip]="command.tooltip || ''" matTooltipClass="tooltip">{{
                                command.materialIconName }}</mat-icon>
                              }
                            </button>
                          </div>
                        }
                      </span>
                    }
                  </div>
                }
              }
            }
          </mat-toolbar>
        }
        @if (tableMenuVisible) {
          <mat-toolbar class="editor-toolbar secondary-group p0 toolbar">
            @for (group of menu$ | async; track group.id) {
              <div class="flex">
                @if ((group.id==='table') && tableMenuVisible) {
                  <span class="flex">
                    @for (command of group.commands; track command.id ?? command.tooltip ?? command.materialIconName ?? $index) {
                      <div class="flex">
                        <button mat-icon-button (click)="execCommand(command)" [disabled]="!command.active">
                          @if (command.svgIcon) {
                            <mat-icon [svgIcon]="command.svgIcon" [matTooltip]="command.tooltip || ''"
                            matTooltipClass="tooltip"></mat-icon>
                          }
                          @if (!command.svgIcon) {
                            <mat-icon [matTooltip]="command.tooltip || ''" matTooltipClass="tooltip">{{
                            command.materialIconName }}</mat-icon>
                          }
                        </button>
                      </div>
                    }
                  </span>
                }
              </div>
            }
          </mat-toolbar>
        }
      }
      <sfo-selection-actions class="selection-actions"></sfo-selection-actions>
    </div>
  }

  <div #editor class="editor" [ngClass]="{ 'labels': showLabels }"></div>
  <!-- <div #editor *ngIf="!hideModals" class="editor" [ngClass]="{ 'disable-event': inActiveMainMenu}"></div> -->
  <div class="editor-bottom-sheet-wrapper">
    <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
  </div>
  <sfo-quick-actions></sfo-quick-actions>
</div>

<ng-template cdkPortal #templatePortals="cdkPortal">
  <mat-form-field>
    <mat-select>
      @for (command of ['h1', 'h2', 'h3', 'h4', 'p', 'quote']; track command) {
        <mat-option [value]="'test'">
          {{ command }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-template>

@if (hideModals) {
  <button color="primary" mat-button class="uppercase right" (click)="updateFootnote()">
    Update
  </button>
}
